(ns minorodata.components.connections.extract-notification-form
  (:require
   [minorodata.app.handlers :refer [dispatch]]
   [mold-forms.core :as form-component]
   [mold-forms.model :refer [->form-model]]
   [react :as react]
   [ui.button]
   [ui.dialog :refer [dialog-actions]]
   [ui.fields :refer [input switch]]
   [ui.tabs :as tabs]))

(defn save-notification-settings [master-id on-success form-state]
  (let [{:keys [slack-webhook ms-teams-webhook email use-account-slack use-account-ms-teams]}
        (form-component/model->fields form-state)]
    (dispatch [:notifications.api/save-notifications
               {:master-id            master-id
                :source-type          "EXTRACT"
                :slack-webhook        slack-webhook
                :ms-teams-webhook     ms-teams-webhook
                :email                email
                :use-account-slack    use-account-slack
                :use-account-ms-teams use-account-ms-teams
                :on-success           on-success}])))

(defn extract-notification-form
  [{:keys [master-id notification account-settings on-success]}]
  (react/useEffect
   (fn []
     (dispatch [:notifications.api/fetch-notification {:master-id master-id}])
     js/undefined)
   #js [master-id])

  (let [form-id (keyword (str "extract-notifications-form-" master-id))]
    [form-component/form
     (->form-model
      {:id        form-id
       :on-submit (partial save-notification-settings master-id on-success)
       :clean-up  #(dispatch [:form-model/delete [:form-model/id form-id]])
       :fields    [{:name  :slack-webhook
                    :value (get notification :slack-webhook "")}
                   {:name  :ms-teams-webhook
                    :value (get notification :ms-teams-webhook "")}
                   {:name  :email
                    :value (get notification :email "")}
                   {:name    :use-account-slack
                    :value   (or (get notification :use-account-slack) false)
                    :process identity}
                   {:name    :use-account-ms-teams
                    :value   (or (get notification :use-account-ms-teams) false)
                    :process identity}]})
     (fn [fields errors on-submit]
       (let [any-error             (->> errors vals (map :value) first)
             use-account-slack?    (get-in fields [:use-account-slack :value])
             use-account-ms-teams? (get-in fields [:use-account-ms-teams :value])]
         [:form {:on-submit on-submit :key master-id}
          [tabs/tabs-root {:default-value "slack"}
           [tabs/tabs-list {:class "mb-4"}
            [tabs/tabs-trigger {:value "slack"} "Slack"]
            [tabs/tabs-trigger {:value "ms-teams"} "MS Teams"]
            [tabs/tabs-trigger {:value "email"} "Email"]]

           [tabs/tabs-content {:value "slack"}
            [:div
             (when (:account-notifications/slack-preference account-settings)
               [switch {:id      :use-account-slack
                        :label   "Use account webhook"
                        :field   (:use-account-slack fields)
                        :classes {:root "mb-4"}}])

             (if use-account-slack?
               [:a {:href   "/admin?tab=notification-preferences"
                    :class  "underline text-kleene-secondary"
                    :target :_blank}
                "You can check your account settings here."]
               [input {:name   :slack-webhook
                       :field  (:slack-webhook fields)
                       :label  "Slack webhook URL"
                       :errors errors
                       :class  "flex-1"}])]]

           [tabs/tabs-content {:value "ms-teams"}
            [:div
             (when (:account-notifications/ms-teams-preference account-settings)
               [switch {:id      :use-account-ms-teams
                        :label   "Use account webhook"
                        :field   (:use-account-ms-teams fields)
                        :classes {:root "mb-4"}}])

             (if use-account-ms-teams?
               [:a {:href   "/admin?tab=notification-preferences"
                    :class  "underline text-kleene-secondary"
                    :target :_blank}
                "You can check your account settings here."]
               [input {:name   :ms-teams-webhook
                       :field  (:ms-teams-webhook fields)
                       :label  "MS Teams webhook URL"
                       :errors errors
                       :class  "flex-1"}])]]

           [tabs/tabs-content {:value "email"}
            [input {:name   :email
                    :field  (:email fields)
                    :label  "Email address"
                    :helper "Enter a single email address or a comma-separated list of email addresses."
                    :errors errors}]]]

          (when (some? any-error)
            [:div {:class "mt-4 mb-4"}
             [:span {:class "text-kleene-error-01"} any-error]])

          [dialog-actions
           [ui.button/button {:type    "submit"
                              :data-cy "extract-save-notifications-btn"}
            "Save notification settings"]]]))]))
